<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'Clients'
}
</script>

<style lang="scss" scoped>
</style>
